import PropTypes from 'prop-types';
export default PropTypes.oneOf([
    'Active',
    'Invitation',
    'Pending'
]);
